import { makeStyles, tokens, Text } from '@fluentui/react-components';
import { MOBILE_BREAKPOINT } from './constants';
import { CONNECTOR_PILLS } from './data';
import { ottoTokens } from '@/theme/ottoTokens';

const useStyles = makeStyles({
  section: {
    paddingBlock: '100px',
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    borderTopColor: tokens.colorNeutralStroke2,
    [`@media (max-width: ${MOBILE_BREAKPOINT})`]: {
      paddingBlock: '64px',
    },
  },
  inner: {
    maxWidth: '1200px',
    marginInline: 'auto',
    paddingInline: tokens.spacingHorizontalXXL,
    [`@media (max-width: ${MOBILE_BREAKPOINT})`]: {
      paddingInline: tokens.spacingHorizontalL,
    },
  },
  head: {
    textAlign: 'center',
    maxWidth: '760px',
    marginInline: 'auto',
    marginBlockEnd: '48px',
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  eyebrow: {
    display: 'block',
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    color: ottoTokens.landingAccentTextCool,
  },
  heading: {
    display: 'block',
    fontSize: 'clamp(28px, 4vw, 44px)',
    fontWeight: tokens.fontWeightBold,
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
    color: tokens.colorNeutralForeground1,
  },
  lead: {
    fontSize: tokens.fontSizeBase400,
    lineHeight: 1.55,
    color: tokens.colorNeutralForeground2,
    maxWidth: '660px',
    marginInline: 'auto',
  },
  pillList: {
    listStyleType: 'none',
    paddingInlineStart: 0,
    margin: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 1fr)',
    gap: tokens.spacingHorizontalS,
    '@media (max-width: 960px)': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    [`@media (max-width: ${MOBILE_BREAKPOINT})`]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
  },
  pill: {
    paddingBlock: tokens.spacingVerticalM,
    paddingInline: tokens.spacingHorizontalM,
    backgroundColor: ottoTokens.landingCardBackground,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusLarge,
    textAlign: 'center',
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightMedium,
    color: tokens.colorNeutralForeground2,
  },
});

export const ConnectorsSection = () => {
  const styles = useStyles();

  return (
    <section className={styles.section} aria-labelledby="connectors-title">
      <div className={styles.inner}>
        <div className={styles.head}>
          <Text className={styles.eyebrow}>1,400+ connectors</Text>
          <Text as="h2" id="connectors-title" className={styles.heading}>
            Connect to everything. No code needed.
          </Text>
          <Text className={styles.lead}>
            Microsoft, Salesforce, SAP, ServiceNow, Snowflake, GitHub, Slack, Jira, Postgres, and a
            thousand more. Create custom API connectors for everything else.
          </Text>
        </div>
        <ul className={styles.pillList} aria-label="Sample of supported connectors">
          {CONNECTOR_PILLS.map((name) => (
            <li key={name} className={styles.pill}>{name}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};
